import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { ReactComponent as SuccessIcon } from 'static/svg/green-check.svg'

import * as S from './styles'

interface SuccessModalProps {
  onClose: () => void
  patientName: string
  planName: string
  scheduleCount: number
}

export function SuccessModal({
  onClose,
  patientName,
  planName,
  scheduleCount,
}: SuccessModalProps): JSX.Element {
  return (
    <ModalGeneric
      modalTitle={
        <S.TitleContainer>
          <SuccessIcon width={50} height={50} />
          <Typography
            center
            weight='bold'
            variant='content1'
          >
            Prontuário salvo com sucesso!
          </Typography>
        </S.TitleContainer>
      }
      btnText='Fechar'
      hasButton
      onCloseModal={onClose}
      btnOnClick={onClose}
    >
      <S.SuccessModalContainer>
        <Typography
          variant='content2'
          center
        >
          {patientName}
        </Typography>
        {scheduleCount && (
          <Typography
            variant='content2'
            weight='bold'
            center
          >
            {scheduleCount}ª consulta realizada
          </Typography>
        )}
        <Typography
          variant='content2'
          center
        >
          {planName}
        </Typography>
      </S.SuccessModalContainer>
    </ModalGeneric>
  )
}